import { showError, showSuccess } from '@calendly/alert'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const KEY = 'local_alerts_message'

const getShowMethod = (status) => {
  if (status === 'success') {
    return showSuccess
  }

  return showError
}

export const useLocalStorageAlerts = () => {
  const dispatch = useDispatch()
  const { localStorage } = window || {}
  const { message, status } = JSON.parse(localStorage?.getItem(KEY) || '{}') || {}
  const showAlert = getShowMethod(status)

  useEffect(() => {
    if (message) {
      localStorage.removeItem(KEY)
      dispatch(showAlert(message))
    }
  }, [dispatch, localStorage, message, showAlert])
}

export const setLocalStorageAlert = (message, status = 'error') => {
  const { localStorage } = window || {}
  localStorage?.setItem(KEY, JSON.stringify({ message, status }))
}
